import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import routes from "./layouts/Routes";
import { Suspense, useEffect, useState } from "react";
import SignIn from "./pages/auth/SignIn";
import { useAppContext } from "./utils/context/AppContext";
import DynamicLoader from "./components/Form/FormFields/DynamicLoader";
import { useSelector } from "react-redux";
import ArtifialIntelligence from "./AI/App";
import { APICONSTANT } from "./utils/api/Config";
import RemarkList from "./components/remark/RemarkList";
export default function AppRouter() {
  const { authToken, loggingOut, setLoggingOut } = useAppContext(); // Use new context name
  const selectorData = useSelector((state) => state?.dynamicData ?? {});
  const isLoading = Boolean(selectorData?.loaders?.[APICONSTANT.login]);
  const isLoggingOut = selectorData.loaders[APICONSTANT.loginOut];
  if (isLoggingOut) {
    return <DynamicLoader loading={true} />;
  }
  return (
    <Routes>
      {!authToken ? (
        <>
          <Route
            path="/"
            element={
              isLoading ? (
                <DynamicLoader loading={true} />
              ) : (
                <Suspense fallback={<p>Loading...</p>}>
                  <SignIn />
                </Suspense>
              )
            }
          />
          <Route
            path="/aiassistant"
            element={
              <Suspense fallback={<p>Loading...</p>}>
                <ArtifialIntelligence />
              </Suspense>
            }
          />
        </>
      ) : (
        <Route element={<MainLayout />}>
          <Route
            path="/"
            element={
              isLoading || loggingOut ? (
                <DynamicLoader loading={true} />
              ) : (
                <Navigate to="/chart/12" replace />
              )
            }
          />
          <Route
            path="/remarks"
            element={
              isLoading || loggingOut ? (
                <DynamicLoader loading={true} />
              ) : (
                <RemarkList />
              )
            }
          />
          {routes.map(({ path, element: Element }, index) => (
            <Route
              key={index}
              path={path}
              element={
                <Suspense fallback={<p>Loading..</p>}>
                  <Element />
                </Suspense>
              }
            />
          ))}
        </Route>
      )}
    </Routes>
  );
}